// extracted by mini-css-extract-plugin
export default {"symbolTabList":"SymbolTabs_symbolTabList__Ladan","products":"Products_products__Mg7WI"};